//* 布局属性
import type { ModulesNavigation } from "@/views/details/components/container/src";
//* 私有组件
import type ModuleComponent1 from "../components/module1/index.vue";
import type ModuleComponent2 from "../components/module2/index.vue";
import type ModuleComponent3 from "../components/module3/index.vue";
import type ModuleComponent4 from "../components/module4/index.vue";
import type ModuleComponent5 from "../components/module5/index.vue";
import type ModuleComponent6 from "../components/module6/index.vue";
import type ModuleComponent7 from "../components/module7/index.vue";
import type ModuleComponent8 from "../components/module8/index.vue";
import type ModuleComponent9 from "../components/module9/index.vue";
//* 样式
import css_father from "../../components/container/style/index.module.less";

import { type LayoutProps } from "../index";

export const useComposable = (define: LayoutProps) => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 节点
    const nodes = {
        module1: ref<InstanceType<typeof ModuleComponent1>>(),
        module2: ref<InstanceType<typeof ModuleComponent2>>(),
        module3: ref<InstanceType<typeof ModuleComponent3>>(),
        module4: ref<InstanceType<typeof ModuleComponent4>>(),
        module5: ref<InstanceType<typeof ModuleComponent5>>(),
        module6: ref<InstanceType<typeof ModuleComponent6>>(),
        module7: ref<InstanceType<typeof ModuleComponent7>>(),
        module8: ref<InstanceType<typeof ModuleComponent8>>(),
        module9: ref<InstanceType<typeof ModuleComponent9>>(),
    };

    //* 响应式变量
    const refs = {
        navigations1: ref<ModulesNavigation[]>([
            { name: i18n.t("BasicInformation"), ref: nodes.module1, index: 1, visible: true },
            { name: i18n.t("SequenceHomology"), ref: nodes.module2, index: 2, visible: true },
            { name: i18n.t("DiseasesMutations"), ref: nodes.module3, index: 3, visible: true },
            { name: i18n.t("TranscriptsProteins"), ref: nodes.module4, index: 4, visible: true },
            { name: i18n.t("GeneExpression"), ref: nodes.module5, index: 5, visible: true },
            { name: i18n.t("ProteinInteraction"), ref: nodes.module6, index: 6, visible: true },
            { name: i18n.t("RelatedModels"), ref: nodes.module9, index: 7, visible: true },
            { name: i18n.t("TargetDrug"), ref: nodes.module7, index: 8, visible: true },
            { name: i18n.t("References"), ref: nodes.module8, index: 9, visible: true },
        ]),
        navigations2: ref<ModulesNavigation[]>([
            { name: i18n.t("BasicInformation"), ref: nodes.module1, index: 1, visible: true },
            { name: i18n.t("SequenceHomology"), ref: nodes.module2, index: 2, visible: true },
            { name: i18n.t("TranscriptsProteins"), ref: nodes.module4, index: 4, visible: true },
            { name: i18n.t("GeneExpression"), ref: nodes.module5, index: 5, visible: true },
            { name: i18n.t("ProteinInteraction"), ref: nodes.module6, index: 6, visible: true },
            { name: i18n.t("RelatedModels"), ref: nodes.module9, index: 7, visible: true },
            { name: i18n.t("References"), ref: nodes.module8, index: 8, visible: true },
        ]),
    };

    //* 函数列表
    const methods = {
        register: (href: string, module: any, method: "POST" | "GET" = "GET") => {
            return api.frontend(href, {
                method: method,
                data: { id: route.params.id, mode: "gene" },
                error: () => module?.hidden(),
                hidden: true,
                success: (response) => {
                    if (!response) module?.hidden();
                    else {
                        module?.render(response);
                    }
                },
            });
        },

        move: (node: any) => {
            if (node && node.$el) {
                const node_container = document.querySelector(`.${css_father["header-container"]}`) as HTMLDivElement;
                const node_name_zh = document.querySelector(`.${css_father["name_zh"]}`) as HTMLDivElement | null;
                const offset = node_container.offsetHeight - (node_name_zh ? node_name_zh.offsetHeight : 0);
                scrollTo({
                    top: node.$el.offsetTop - offset,
                    behavior: "smooth",
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        options: computed(() => {
            return {
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/e1e38b56-0591-4a56-8d03-00dde15b07da.webp",
                navigations: define.species == 9606 ? refs.navigations1.value : refs.navigations2.value,
            };
        }),
    };

    return { refs, nodes, methods, computeds };
};
